var render = function render(){var _vm=this,_c=_vm._self._c;return _c('messages',{attrs:{"message-items":_vm.mails,"props":_vm.props},on:{"read-mail":_vm.onReadMail,"tabs-change":_vm.onTabsChange,"all-read":_vm.onAllRead,"previous":_vm.onPrevious,"next":_vm.onNext,"search":_vm.onSearch}})
}
var staticRenderFns = []

export { render, staticRenderFns }